module.exports = __webpack_public_path__ + "media/images/everfactor-4885dc7ce993d71be0998e6211e86ef4.ico";